export const getTagColorStyles = (str) => {
  if (!str) {
    return {};
  }

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;

  return {
    backgroundColor: `hsl(${hue}, 70%, 92%)`, // light background
    color: `hsl(${hue}, 40%, 30%)`, // dark text
    border: "none",
  };
};
